import type { OrganizationDetails } from 'storefront-modules/seo/jsonld/organization'

/** Company facts: the homepage Organization JSON-LD and the footer show the same data. */
export const COMPANY = {
  type: 'Organization',
  legalName: 'Granditude AB',
  taxID: '556919-8301',
  foundingDate: '2013',
  founders: ['Jens Forsell', 'Joakim Bissmark'],
  email: 'info@granditude.com',
  telephone: '+46708406951',
  streetAddress: 'Drottninggatan 71C',
  postalCode: '111 36',
  addressLocality: 'Stockholm',
  addressCountry: 'SE',
  sameAs: ['https://www.linkedin.com/company/granditude']
} satisfies OrganizationDetails
